import React, { useState } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import Config from "config";
import DeleteButton from "components/Common/DeleteButtonList";

function TableComponent({ title, data, header, itemsPerPage }) {
  const [currentPage, setCurrentPage] = useState(0);
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const offset = currentPage * itemsPerPage;
  const paginatedData = data.slice(offset, offset + itemsPerPage);

  return (
    <div className="table-responsive" style={{ fontFamily: "sans-serif" }}>
      <table className="table">
        <thead>
          <tr>
            {title?.can_edit == false &&
            title?.can_show == false &&
            title?.can_destroy == false ? (
              <th></th>
            ) : (
              <th style={{ cursor: "default" }} key="Action" className="text">
                Action
              </th>
            )}
            {header.map((column, index) => (
              <th key={index} style={{ whiteSpace: "nowrap" }}>
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody style={{ whiteSpace: "nowrap" }}>
          {paginatedData.length > 0 ? (
            <>
              {paginatedData.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  <td>
                    <ul className="list-unstyled hstack gap-1 mb-0">
                      {title?.can_show ? (
                        <li
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="View"
                        >
                          <Link
                            className="btn btn-sm btn-soft-primary"
                            id={`viewtooltip-${rowIndex}`}
                            to={`${backUrl}/sauvegardes_attestations/${row.id}`}
                          >
                            <i className="mdi mdi-eye-outline"></i>
                          </Link>
                        </li>
                      ) : null}
                      {title?.can_edit ? (
                        <li title="Editer">
                          <Link
                            className="btn btn-sm btn-soft-info"
                            id={`edittooltip-${rowIndex}`}
                            to={`${backUrl}/sauvegardes_attestations/${row.id}/edit`}
                          >
                            <i className="mdi mdi-pencil-outline"></i>
                          </Link>
                        </li>
                      ) : null}
                      {title?.can_destroy ? (
                        <li title="Supprimer">
                          <DeleteButton
                            url={`https://www.fluxod.com/${api}/sauvegardes_attestations/${row.id}`}
                          />
                        </li>
                      ) : null}
                    </ul>
                  </td>
                  <td>{row.types_publipostage_id}</td>
                  <td>{row.impression_id}</td>
                  <td>{row.pme_id}</td>
                  <td>{row.investissement_id}</td>
                  <td>{row.date}</td>
                  <td style={{ textAlign: "center" }}>{row.annee_id}</td>
                  <td>
                    {row?.fichier != null ? (
                      <a href={row.fichier} download>
                        <i
                          style={{
                            fontSize: "25px",
                            paddingLeft: "8px",
                            textalign: "center",
                            verticalalign: "middle",
                          }}
                          className="bx bx-download"
                        ></i>
                      </a>
                    ) : null}
                  </td>
                  <td>{row.signature_en_cours}</td>
                  <td>
                    {row?.fichier_signe != null ? (
                      <a href={row.fichier_signe} download>
                        <i
                          style={{
                            fontSize: "25px",
                            paddingLeft: "8px",
                            textalign: "center",
                            verticalalign: "middle",
                          }}
                          className="bx bx-download"
                        ></i>
                      </a>
                    ) : null}
                  </td>
                </tr>
              ))}
            </>
          ) : (
            <tr>
              <td colSpan={header.length} style={{ textAlign: "center" }}>
                Aucune donnée à afficher
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <ReactPaginate
        previousLabel={"<<"}
        breakLabel={"..."}
        nextLabel={">>"}
        pageCount={Math.ceil(data.length / itemsPerPage)}
        marginPagesDisplayed={2}
        pageRangeDisplayed={3}
        onPageChange={handlePageChange}
        containerClassName={"pagination justify-content-center"}
        pageClassName={"page-item"}
        pageLinkClassName={"page-link"}
        previousClassName={"page-item"}
        previousLinkClassName={"page-link"}
        nextClassName={"page-item"}
        nextLinkClassName={"page-link"}
        breakClassName={"page-item"}
        breakLinkClassName={"page-link"}
        activeClassName={"active"}
      />
    </div>
  );
}

export default TableComponent;
